export default function EditRoleSection({
  label,
  hint,
  accent,
  children,
}: {
  label: string;
  hint?: string;
  accent?: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <label className="text-[12px] font-semibold text-bark-800 dark:text-[#e8ece9]">
          {label}
        </label>
        {accent && (
          <span className="text-[10.5px] text-stone-500 dark:text-stone-400">{accent}</span>
        )}
      </div>
      {children}
      {hint && (
        <div className="text-[11px] text-stone-500 dark:text-stone-400 mt-1.5 leading-snug">
          {hint}
        </div>
      )}
    </div>
  );
}
